import { EVENT_DEFAULT_ERROR_MESSAGE } from '../constants';
import { NosRolloutApiResponse } from '../models/nosRollout';
import { fetchV3WithTranslateServerErrors } from './base';
import { _getNosRolloutUrl } from './constants';

export const ERROR_SPEC = {
    default: () => EVENT_DEFAULT_ERROR_MESSAGE,
};

export const getNosRollout = ({
    organizationId,
    eventId,
}: {
    organizationId: string;
    eventId: string;
}) =>
    fetchV3WithTranslateServerErrors<NosRolloutApiResponse>(
        ERROR_SPEC,
        _getNosRolloutUrl({ organizationId, eventId }),
        {
            method: 'GET',
        },
    );
